import siteMetadata from './siteMetadata';

export const getShortLang = lang => lang && lang.slice(0, 2);

export const slugizy = text =>
  text
    ? text
        .toLowerCase()
        .replace(/^-+|-+$|[':"?’`~]/g, '')
        .replace(/\s+/g, '-')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    : '';

export const getSlug = blogPost => (blogPost.data ? blogPost.data.slug || slugizy(blogPost.data.title) : '');

export const getLangPath = lang => {
  const shortLang = getShortLang(lang);
  const shortDefaultLang = getShortLang(siteMetadata.defaultLang);

  return shortLang === shortDefaultLang ? '' : `/${shortLang}`;
};

export const getPublicationDate = blogPost => blogPost.data.publication_date || blogPost.first_publication_date;

export const reduceSlices = slices =>
  slices.reduce((result, slice) => {
    return {
      ...result,
      [slice.slice_type]: {
        primary: slice.primary,
        items: slice.items,
      },
    };
  }, {});

export const getExcerpt = (content, wordlimit) => {
  const filter = content.replace(/\s+/g, ' ');
  const wordsarr = filter.split(' ');

  if (wordsarr.length < wordlimit) {
    return content;
  }

  const words = wordsarr.slice(0, wordlimit);

  return `${words.join(' ')}...`;
};

export const getReviewsRate = (reviews = []) => {
  if (!reviews.length) {
    return 0;
  }

  const sum = reviews.reduce((total, review) => {
    if (!review.rating) {
      return total;
    }

    return total + review.rating;
  }, 0);

  return (sum / reviews.length).toFixed(2);
};

export const isGoogleReviewsEnabled = process.env.IS_GOOGLE_REVIEWS_ENABLED === 'true';
